import { useEffect } from "react";
import { getCurrentUser } from "../../../../../global/paywall/paywallUtils";


export const PremiumPaywallMobileSigninFinish = () => {


  useEffect(() => {
    const timeout = setTimeout(() => {
      location.reload();
    }, 3000);
    return () => clearTimeout(timeout);
  }, []);

  const user = getCurrentUser()
  const displayName = user && user.displayName || 'משתמש';

  return (
    <div className="premium-paywall-mobile-signin-finish">
      <div className="title">{`שלום ${displayName}`}</div>
      <div className="subtitle">
        שמחים שחזרת, מיד תיפתח הכתבה
      </div>

      <div className="resend-code-text">
        העמוד לא התרענן?<button onClick={() => window.location.reload()}>לחצו כאן</button>
      </div>
    </div>
  )
}
